module.exports = __webpack_public_path__ + "img/b.c05e8e6a.svg";